import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { eDmLoaiThuBoSungKienThucActionsObj } from "./../../action-types/category/IDmLoaiThuBoSungKienThucActions";

export const loaiThuBoSungKienThucActions = {
  ...generateActions(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "DELETE_MANY_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "DELETE_MANY_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "SAVE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    },
  ),
  ...generateActionForKey(
    eDmLoaiThuBoSungKienThucActionsObj,
    "LOAI_THU_BO_SUNG_KIEN_THUC",
    "SAVE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Thất bại");
    },
  ),
};
